import { updateAccessToken, updateRefreshToken } from '@gef-ui/redux-common/actions/appContext';
import o from "ramda/es/o";
import prop from "ramda/es/prop";
import { oauthTokenTypes } from '../constants';
const bodyP = prop('body');
export const setAccessToken = o(o(updateAccessToken, prop(oauthTokenTypes.ACCESS)), bodyP);
export const setRefreshToken = o(o(updateRefreshToken, prop(oauthTokenTypes.REFRESH)), bodyP);
